import React, { useState, useEffect, useRef } from 'react';

import { ScrollArea } from "@/components/ui/scroll-area";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

import { useRecoilState } from 'recoil';
import { tokenAtom } from 'core/config/atoms';

import { toast } from 'react-toastify';
import moment from 'moment';
import { motion } from "framer-motion";
import Lottie from 'lottie-react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';

import { Plus, Trash } from "lucide-react";

import animBtnLoading from 'assets/anim/anim-btnLoading.json';

import TopBar from 'core/widgets/ui/TopBar';

import ServiceWorkshop from 'services/serviceWorkshop';
import ServiceUtility from 'services/serviceUtility';

import { API_URL } from 'services/models/AppConstent';

const allowedExtensions = ["png", "jpeg"];

export default function PanelWorkshop() {

    const fieldARef = useRef('');
    const fieldBRef = useRef('');

    const [token] = useRecoilState(tokenAtom);

    const [records, setRecords] = useState([]);
    const [urecord, setURecord] = useState({});

    const [isOpen, setIsOpen] = useState(false);
    const [submit, setSubmit] = useState(false);

    const [thubFile, setThubFile] = useState(null);
    const [thubPreview, setThubPreview] = useState(null);

    const [progress, setProgress] = useState(0);

    const workshopService = new ServiceWorkshop();
    const utilService = new ServiceUtility();

    const formVSchema = Yup.object().shape({
        age: Yup.string().required('This information is required'),
        duration: Yup.string().required('This information is required'),
        timings: Yup.string().required('This information is required'),
        resource: Yup.string().required('This information is required'),
        language: Yup.string().required('This information is required')
    });

    const { values, errors, touched, handleChange, handleSubmit, handleReset, setValues } = useFormik({
        initialValues: {
            age: '',
            duration: '',
            groupTitle: '',
            durationTitle: '',
            timings: '',
            resource: '',
            language: '',
        },
        enableReinitialze: true,
        validationSchema: formVSchema,
        onSubmit: values => {
            setSubmit(true);
            if (urecord.pointers.length === 0) {
                toast.error("Add atleast one key pointer in workshop!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            } else {
                let body = {
                    "uid": urecord._id,
                    "data": {
                        "pointers": urecord.pointers,
                        "age": values.age,
                        "duration": values.duration,
                        "timings": values.timings,
                        "resource": values.resource,
                        "language": values.language,
                        "groupTitle": values.groupTitle,
                        "durationTitle": values.durationTitle,
                    }
                }
                workshopService.updateWorkshop(body, token).then((res) => {
                    setSubmit(false);
                    if (res.status) {
                        toast.success("Workshop data updated!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                        setIsOpen(false);
                        setURecord({});
                        loadData();
                        setThubFile(null);
                        setThubPreview(null);
                        handleReset();
                    } else {
                        toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    }
                });
            }
        },
    });

    const handleFileChange = (e) => {
        var { value, name } = e.target;
        let isError = false;

        const inputFile = e.target.files[0];
        const fileExtension = inputFile?.type.split("/")[1];

        if (!allowedExtensions.includes(fileExtension)) {
            alert.show("Only .png file format is allowed, please try again!", { type: 'error' });
            isError = true;
        }

        if (isError) {
            return;
        }

        setThubFile(inputFile);

        const reader = new FileReader();
        reader.onload = () => {
            setThubPreview(reader.result);
        };
        reader.readAsDataURL(inputFile);
    };

    const AddItem = () => {
        let val = fieldARef.current.value;
        if (val.length !== 0) {
            let newRecord = { ...urecord };
            if (newRecord.pointers.length < 7) {
                newRecord.pointers.push(fieldARef.current.value);
                setURecord(newRecord);
            } else {
                toast.error('Maximum pointer limit reached.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        }
        fieldARef.current.value = "";
    }

    const AddModule = () => {
        let val = fieldBRef.current.value;
        if (val.length !== 0) {
            if (thubFile !== null) {
                let newRecord = { ...urecord };
                if (newRecord.modules.length < 4) {
                    setSubmit(true);
                    (async function () {
                        var formData = new FormData();
                        formData.append("path", 'workshop');
                        formData.append("doc", thubFile);

                        setProgress(0);
                        var url = `${API_URL}file/uploadFile`;
                        var requestHeaders = {
                            'Content-type': 'multipart/form-data',
                            'Accept': '*/*',
                            'Authorization': `bearer ${token}`,
                        };

                        const responseFile = await axios.post(url, formData, {
                            headers: requestHeaders,
                            onUploadProgress: (progressEvent) => {
                                const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                                setProgress(progress);
                            },
                        });
                        let resFile = responseFile.data.data;
                        setProgress(0);

                        let tempModule = [...urecord.modules];
                        tempModule.push({ title: val, media: resFile });

                        let body = {
                            "uid": urecord._id,
                            "data": {
                                "modules": tempModule,
                            }
                        }
                        workshopService.updateWorkshop(body, token).then((res) => {
                            setSubmit(false);
                            if (res.status) {
                                toast.success("Workshop data updated!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                                setIsOpen(false);
                                setURecord({});
                                setThubFile(null);
                                setThubPreview(null);
                                loadData();
                                handleReset();
                            } else {
                                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                            }
                        });
                    })();
                } else {
                    toast.error('Maximum pointer limit reached.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                }
            } else {
                toast.error('Please select file to upload.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        }
        fieldBRef.current.value = "";
    }

    const RemoveModule = (index) => {
        let delM = urecord.modules[index];
        setSubmit(true);
        utilService.deleteFile({ path: delM.media.fileurl }, token).then((res) => {
            let tempModule = [...urecord.modules];
            tempModule.splice(index, 1);
            let body = {
                "uid": urecord._id,
                "data": {
                    "modules": tempModule,
                }
            }
            workshopService.updateWorkshop(body, token).then((res) => {
                setSubmit(false);
                if (res.status) {
                    toast.success("Workshop data updated!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    setIsOpen(false);
                    setURecord({});
                    setThubFile(null);
                    setThubPreview(null);
                    loadData();
                    handleReset();
                } else {
                    toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                }
            });
        });
    }

    const RemoveItem = (index) => {
        let newRecord = { ...urecord };
        newRecord.pointers.splice(index, 1);
        setURecord(newRecord);
    }

    const loadData = () => {
        (async function () {
            let body = {
                "filter": {},
                "page": 1,
                "size": 10,
                "searchQuery": "",
                "startDate": "",
                "endDate": ""
            };
            var res = await workshopService.getAllWorkshop(body, token);
            if (res['status']) {
                setRecords(res.data.data);
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        })();
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div className="w-full h-full py-3 px-3">
            {
                isOpen && <div className='overflow-y-auto overflow-x-hidden z-50 w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-[600px] absolute right-0 min-h-screen p-[12px]'>
                        <ScrollArea>
                            <div className='px-4'>
                                <form onSubmit={handleSubmit}>
                                    <div className='flex items-center justify-between text-2xl'>
                                        <h1 className='font-sans font-medium text-gray-900'>Update Workshop</h1>
                                        <span onClick={() => {
                                            setIsOpen(false);
                                            setURecord({});
                                            setThubFile(null);
                                            setThubPreview(null);
                                            loadData();
                                            handleReset();
                                        }}><i className="las la-times text-xl text-gray-700 cursor-pointer"></i></span>
                                    </div>
                                    <hr className='my-4' />
                                    <div className="mb-8 space-y-4">

                                        <div className="w-full">
                                            <label className="block text-xs font-medium text-gray-700 font-mono">Age</label>
                                            <input type="text" id="age" onChange={handleChange} autoComplete="off" className="mt-1 p-2 block w-full h-9 bg-white text-sm border-gray-300 border rounded outline-1 outline-blue-200" placeholder="i.e. Age Group" value={values.age} />
                                            {(errors.age && touched.age) && <p className='text-xs text-red-400 mt-1'>{errors.age}</p>}
                                        </div>

                                        <div className="w-full">
                                            <label className="block text-xs font-medium text-gray-700 font-mono">Duration</label>
                                            <input type="text" id="duration" onChange={handleChange} autoComplete="off" className="mt-1 p-2 block w-full h-9 bg-white text-sm border-gray-300 border rounded outline-1 outline-blue-200" placeholder="i.e. Duration" value={values.duration} />
                                            {(errors.duration && touched.duration) && <p className='text-xs text-red-400 mt-1'>{errors.duration}</p>}
                                        </div>

                                        <div className="w-full">
                                            <label className="block text-xs font-medium text-gray-700 font-mono">Timings</label>
                                            <input type="text" id="timings" onChange={handleChange} autoComplete="off" className="mt-1 p-2 block w-full h-9 bg-white text-sm border-gray-300 border rounded outline-1 outline-blue-200" placeholder="i.e. Timings" value={values.timings} />
                                            {(errors.timings && touched.timings) && <p className='text-xs text-red-400 mt-1'>{errors.timings}</p>}
                                        </div>

                                        <div className="w-full">
                                            <label className="block text-xs font-medium text-gray-700 font-mono">Resource</label>
                                            <input type="text" id="resource" onChange={handleChange} autoComplete="off" className="mt-1 p-2 block w-full h-9 bg-white text-sm border-gray-300 border rounded outline-1 outline-blue-200" placeholder="i.e. Resource Persons" value={values.resource} />
                                            {(errors.resource && touched.resource) && <p className='text-xs text-red-400 mt-1'>{errors.resource}</p>}
                                        </div>

                                        <div className="w-full">
                                            <label className="block text-xs font-medium text-gray-700 font-mono">Language</label>
                                            <input type="text" id="language" onChange={handleChange} autoComplete="off" className="mt-1 p-2 block w-full h-9 bg-white text-sm border-gray-300 border rounded outline-1 outline-blue-200" placeholder="i.e. Language" value={values.language} />
                                            {(errors.language && touched.language) && <p className='text-xs text-red-400 mt-1'>{errors.language}</p>}
                                        </div>

                                        <div className="w-full">
                                            <label className="block text-xs font-medium text-gray-700 font-mono">Group Title</label>
                                            <input type="text" id="groupTitle" onChange={handleChange} autoComplete="off" className="mt-1 p-2 block w-full h-9 bg-white text-sm border-gray-300 border rounded outline-1 outline-blue-200" placeholder="i.e. Group Title" value={values.groupTitle} />
                                            {(errors.groupTitle && touched.groupTitle) && <p className='text-xs text-red-400 mt-1'>{errors.groupTitle}</p>}
                                        </div>

                                        <div className="w-full">
                                            <label className="block text-xs font-medium text-gray-700 font-mono">Duration Title</label>
                                            <input type="text" id="durationTitle" onChange={handleChange} autoComplete="off" className="mt-1 p-2 block w-full h-9 bg-white text-sm border-gray-300 border rounded outline-1 outline-blue-200" placeholder="i.e. Duration Title" value={values.durationTitle} />
                                            {(errors.durationTitle && touched.durationTitle) && <p className='text-xs text-red-400 mt-1'>{errors.durationTitle}</p>}
                                        </div>

                                        <hr className='my-2' />
                                        <div className='p-2 bg-gray-200 w-full text-sm font-medium rounded mt-4 flex justify-between items-center'>
                                            <span className='flex items-center'>
                                                <i className="las la-file-invoice mr-2 text-xl"></i>Modules (Min 1)
                                            </span>
                                        </div>

                                        <div className="w-full">
                                            <div className='flex items-center justify-between'>
                                                {
                                                    (thubFile === null) && <div className="mt-1 flex justify-center p-2 border-2 border-gray-300 border-dashed rounded-md">
                                                        <div className="space-y-1 text-center">
                                                            <svg className="mx-auto h-8 w-8 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                                                                <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                            <div className="flex flex-col text-xs text-gray-600">
                                                                <label className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                                                                    <span>Upload a file</span>
                                                                    <input type="file" className="sr-only" onChange={handleFileChange} />
                                                                </label>
                                                                <p className="pl-1">or drag and drop</p>
                                                            </div>
                                                            <p className="text-[10px] text-gray-500">
                                                                .jpg or .png up to 1mb at 1:1 Ration
                                                            </p>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    thubFile !== null && <div className="w-20 flex flex-col items-start">
                                                        <div className="w-20 rounded-md">
                                                            <img src={thubPreview} alt="Icon Template" className='w-20 h-20 rounded-md border' />
                                                        </div>
                                                        <div className="">
                                                            <label className="text-xs relative cursor-pointer rounded-md font-medium text-indigo-600 font-mono">
                                                                <span>Replace</span>
                                                                <input type="file" className="sr-only" onChange={handleFileChange} />
                                                            </label>
                                                        </div>
                                                    </div>
                                                }
                                                <input type="text" id="module" autoComplete="off" className="ml-4 mt-1 p-2 block w-full h-9 bg-white text-sm border-gray-300 border rounded outline-1 outline-blue-200" placeholder="i.e. Module" ref={fieldBRef} />
                                                <div className='w-6 h-6 border rounded flex items-center justify-center text-blue-600 border-blue-600 cursor-pointer ml-2' onClick={() => { AddModule(); }}>
                                                    <Plus size={16} />
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            submit && <div className='my-3'>
                                                <p className='text-xs text-gray-400'>Uploading....</p>
                                                <div className='w-full bg-gray-300 mt-1' style={{ height: '4px' }}>
                                                    <div style={{ width: `${progress}%`, transitionDuration: `4s` }} className="h-full transition-all bg-green-400"></div>
                                                </div>
                                            </div>
                                        }
                                        <hr />

                                        <div className='space-y-1'>
                                            {
                                                urecord.modules.map((module, index) => {
                                                    return <div className='flex items-center justify-between'>
                                                        <div className='flex'>
                                                            <div className="w-20 flex flex-col items-start">
                                                                <div className="w-20 rounded-md">
                                                                    <img src={module.media.fileurl} alt="Icon Template" className='w-20 h-20 rounded-md border' />
                                                                </div>
                                                            </div>
                                                            <p className='ml-2'>{module.title}</p>
                                                        </div>
                                                        <div className='w-6 h-6 border rounded flex items-center justify-center text-red-600 border-red-600 cursor-pointer' onClick={() => {
                                                            RemoveModule(index);
                                                        }}>
                                                            <Trash size={16} />
                                                        </div>
                                                    </div>
                                                })
                                            }
                                            {
                                                urecord.modules.length === 0 && <div className='flex items-center justify-between'>
                                                    <p className='text-xs'>No modules found.</p>
                                                </div>
                                            }
                                        </div>

                                        <hr className='my-2' />
                                        <div className='p-2 bg-gray-200 w-full text-sm font-medium rounded mt-4 flex justify-between items-center'>
                                            <span className='flex items-center'>
                                                <i className="las la-file-invoice mr-2 text-xl"></i>Key Pointers (Max 7)
                                            </span>
                                        </div>

                                        <div className="w-full">
                                            <label className="block text-xs font-medium text-gray-700 font-mono">Key Point</label>
                                            <div className='flex items-center justify-between'>
                                                <input type="text" id="pointer" autoComplete="off" className="mt-1 p-2 block w-full h-9 bg-white text-sm border-gray-300 border rounded outline-1 outline-blue-200" placeholder="i.e. Pointer" ref={fieldARef} />
                                                <div className='w-6 h-6 border rounded flex items-center justify-center text-blue-600 border-blue-600 cursor-pointer ml-2' onClick={() => { AddItem(); }}>
                                                    <Plus size={16} />
                                                </div>
                                            </div>
                                        </div>
                                        <hr />

                                        <div className='space-y-2'>
                                            {
                                                urecord.pointers.map((point, index) => {
                                                    return <div className='flex items-center justify-between'>
                                                        <p>{point}</p>
                                                        <div className='w-6 h-6 border rounded flex items-center justify-center text-red-600 border-red-600 cursor-pointer' onClick={() => {
                                                            RemoveItem(index);
                                                        }}>
                                                            <Trash size={16} />
                                                        </div>
                                                    </div>
                                                })
                                            }
                                        </div>
                                    </div>
                                    <div className='w-full'>
                                        <button type="submit" className="w-full text-white bg-primeLight hover:bg-prime focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center flex items-center justify-center" disabled={submit}>
                                            {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                            {!submit && "UPDATE"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </ScrollArea>
                    </div>
                </div>
            }
            <ScrollArea className="w-full h-full py-3 px-3">
                <div className="grid grid-cols-12 grid-gap-2">
                    <div className="col-span-12 mt-2">
                        <div class="intro-y flex items-center justify-between h-10 border-b pb-4">
                            <h2 class="text-2xl font-medium font-serif truncate ml-2 text-prime">
                                Workshop CMS
                            </h2>
                            <div className='flex z-50'>
                                <TopBar />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-span-12 mt-4 px-2">
                    <div className="w-full shadow-md rounded-md border">
                        <table className="min-w-full divide-y divide-gray-200 px-4">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        #NUMBER
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        Web page
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        Updated At
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"></th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {
                                    records.length !== 0 && records.map((record, index) => {
                                        return <tr className="hover:bg-gray-100" key={index}>
                                            <td className="px-6 py-4 whitespace-nowrap cursor-pointer">
                                                <div className="text-sm font-bold text-gray-900">
                                                    <div className='flex items-center text-prime'>
                                                        {index + 1}
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4">
                                                <span className="inline-flex text-sm leading-5 font-semibold text-gray-900">
                                                    {record.type}
                                                </span>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-blue-600">
                                                    {moment(record.updatedAt).format('DD MMM, yyyy')}
                                                </div>
                                            </td>
                                            <td>
                                                <DropdownMenu>
                                                    <DropdownMenuTrigger>
                                                        <motion.i whileHover={{ scale: 1.1 }} class="las la-ellipsis-v text-lg"></motion.i>
                                                    </DropdownMenuTrigger>
                                                    <DropdownMenuContent>
                                                        <div className='bg-white shadow-md rounded-md absolute' style={{ top: '0px', left: '-60px' }}>
                                                            <div>
                                                                <ul className='flex flex-col items-start p-2'>
                                                                    <DropdownMenuItem>
                                                                        <li className='w-40 cursor-pointer rounded-md' onClick={() => {
                                                                            setValues({ ...values, age: record.age, groupTitle: record.groupTitle, durationTitle: record.durationTitle, duration: record.duration, timings: record.timings, resource: record.resource, language: record.language });
                                                                            setURecord(record);
                                                                            setIsOpen(true);
                                                                        }}>
                                                                            <div className='flex items-center text-base'>
                                                                                <i className="las la-pen text-lg"></i>
                                                                                <p className='text-sm font-serif ml-2'>Edit</p>
                                                                            </div>
                                                                        </li>
                                                                    </DropdownMenuItem>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </DropdownMenuContent>
                                                </DropdownMenu>
                                            </td>
                                        </tr>
                                    })
                                }
                                {
                                    records.length === 0 && <tr className="cursor-pointer hover:bg-gray-100">
                                        <td className="px-6 py-4 whitespace-nowrap" colSpan="4">
                                            <div className="text-sm text-red-600 text-center">
                                                No data found.
                                            </div>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </ScrollArea>
        </div>
    )
}
